import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'User chose to leave the canvas and return to the asset they opened the canvas from (version target), from the bottom bar or the post-save toast.',
  name: 'canvas_back_to_asset_clicked',
  params: [
    {
      description: 'The id of the canvas, omitted while the canvas is still an unsaved draft',
      name: 'canvas_id',
      required: false,
      type: 'string',
    },
    {
      description: 'Where the user clicked back to the asset',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['version_target_bar', 'saved_version_toast'],
    },
  ],
};

export default META;
